var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.ready)?_c('router-view'):_vm._e(),_c('portal',{attrs:{"to":"outsideMain"}},[_c('keep-alive',[_c('property-ancient-history',{attrs:{"resource":_vm.propertyResource}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }